import axios from "axios";
import { ArquivoUpload } from "models/arquivo_upload";
import { CentroCusto } from "models/centro_custo_type";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ContasPagar } from "models/contas_pagar";
import { ContaFinanceiro } from "models/conta_financeiro";
import { Depto } from "models/depto_type";
import { FinanceCategoryType } from "models/finance_category";
import { LancamentoFinanceiro } from "models/lancamento_type";
import { OrcamentoDepto } from "models/orcamento_departamento";
import { PessoaType } from "models/person_type";
import { SubFinanceType } from "models/sub_finance_category";
import { UsuarioModel } from "models/user_model";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import useSubCategory from "../../subCategories/hooks/useSubCategory";

const useContasPagar = () => {
  const [list, setAccountTypeList] = useState<ContasPagar[]>([]);
  const [listDepto, setListDepto] = useState<OrcamentoDepto[]>([]);
  const [selectedDeptoOrcamento, setSelectedDeptoOrcamento] = useState<OrcamentoDepto>(null);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [error, setError] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [accountSelected, setAccountSelected] = useState<ContasPagar>(null);
  const [depto, setDepto] = useState<Depto[]>([]);
  const [selectedDepto, setSelectedDepto] = useState<Depto>(null);
  const [categoria, setCategoria] = useState<FinanceCategoryType[]>([]);
  const [itemList, setItemList] = useState<LancamentoFinanceiro[]>([]);
  const [oldList, setOldList] = useState<LancamentoFinanceiro[]>([]);
  const [selectedCategoria, setSelectedCategoria] =
    useState<FinanceCategoryType>(null);

  const [subcategoria, setSubCategoria] = useState<SubFinanceType[]>([]);
  const [selectedSubCategoria, setSelectedSubCategoria] =
    useState<SubFinanceType>(null);
  const [centroCusto, setCentroCusto] = useState<CentroCusto[]>([]);
  const [selectedCentroCusto, setSelectedCentroCusto] =
    useState<CentroCusto>(null);
  const [condicaoPagamentos, setCondicaoPagamentos] = useState<
    CondicaoPagamento[]
  >([]);
  const [selectedCondicaoPagamentos, setSelectedCondicaoPagamentos] =
    useState<CondicaoPagamento>(null);
  const [fornecedores, setFornecedores] = useState<PessoaType[]>([]);
  const [selectedFornecedor, setSelectedFornecedor] =
    useState<PessoaType>(null);
  const cancelRef = useRef();

    const [contaFinanceiroLista, setContaFinanceiroLista] = useState<
      ContaFinanceiro[]
    >([]);
    const [selectedConta, setSelectedConta] = useState<ContaFinanceiro>(null);
    const [users, setUsers] = useState<UsuarioModel[]>([]);
    const [selectedUser, setSelectedUser] = useState<UsuarioModel>();
  const { lista } = useSubCategory();
  const [filiais, setFilial] = useState<PessoaType[]>();
  const [selectedFilial, setSelectedFilial] = useState<PessoaType>();

  const showModal = (show: boolean) => {
    setShow(show);
    setError(false);
    if (!show) {
      cleanInput();
    }
  };

  const loadData = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/contas-pagar/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setAccountTypeList(response.data);
    }
  };

  const loadPagamento = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);

    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/condicao-pagamento/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setCondicaoPagamentos(response.data);
    }
  };

  const loadDepto = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/departamento/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setDepto(response.data);
    }
  };

  const loadCategory = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/financeiro-categoria/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setCategoria(response.data);
    }
  };

  const loadFornecedores = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/projeto/fornecedor/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setFornecedores(response.data);
    }
  };

  const loadContaFinaceiro = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/conta-financeiro/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setContaFinanceiroLista(response.data);
    }
  };

  const loadUsers = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/user/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setUsers(response.data);
    }
  };

  const loadOrcamentoDepto = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/orcament-departamento/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setListDepto(response.data);
    }
  };

  const validateField = (condition: any, errorMessage: string) => {
    if (!condition) {
      showError("Erro!", errorMessage);
      return false;
    }
    return true;
  };

  const validate = () => {
    let response = true;

    const total = itemList.reduce((value, acc) => acc.valor + value, 0);
    const validateItem = total < accountSelected.valor;

    response =
      validateField(
        !validateItem,
        "O valor dos lançamentos não pode ser menor do que o valor total"
      ) && response;
    response =
      validateField(selectedCategoria, "Selecione a categaria da CONTA") &&
      response;
    response =
      validateField(selectedCentroCusto, "Selecione o Centro de Custo") &&
      response;
    response =
      validateField(selectedFornecedor, "Selecione o fornecedor da CONTA") &&
      response;
    response =
      validateField(selectedDepto, "Selecione o Departamento") && response;
    response =
      validateField(
        selectedCondicaoPagamentos,
        "Selecione a Forma de Pagamento"
      ) && response;
      response =
      validateField(
        selectedUser,
        "Selecione o Responsável"
      ) && response;
    response =
      validateField(
        accountSelected?.vencOriginal,
        "Selecione o Vencimento Original"
      ) && response;
    response =
      validateField(accountSelected?.vencimento, "Selecione o Vencimento") &&
      response;
    response =
      validateField(
        accountSelected?.valor && accountSelected.valor >= 0,
        "Preencha Corretamente o valor"
      ) && response;
    response =
      validateField(
        accountSelected?.numDocumento,
        "Preencha Corretamente o Número do Documento"
      ) && response;
    response =
      validateField(
        accountSelected?.dataEmissao,
        "Preencha Corretamente a Data de Emissão"
      ) && response;
    response =
      validateField(
        accountSelected?.competencia,
        "Preencha Corretamente a Data de Competência"
      ) && response;
    response =
      validateField(
        accountSelected?.historico,
        "Preencha Corretamente o histórico da conta"
      ) && response;
    response =
      validateField(
        accountSelected?.parcelaVencimento,
        "Preencha Corretamente o dia de vencimento da Parcela"
      ) && response;
    response =
      validateField(
        selectedSubCategoria,
        "Preencha Corretamente a subcategoria financeira"
      ) && response;

      response =
      validateField(
        accountSelected?.origem,
        "Preencha Corretamente o campo Origem"
      ) && response;

      response =
      validateField(
        selectedConta ,
        "Preencha Corretamente a conta para baixa"
      ) && response;

      response =
      validateField(
        selectedDeptoOrcamento ,
        "Preencha Corretamente o Planejamento Financeiro"
      ) && response;

    return response;
  };

  const add = () => {
    showModal(true);
  };

  const cleanInput = () => {
    setAccountSelected(null);
    setSelectedCategoria(null);
    setSelectedDepto(null);
    setSelectedCondicaoPagamentos(null);
    setSelectedFornecedor(null);
    setSelectedSubCategoria(null);
    setSelectedConta(null);
    setSelectedUser(null);
    setSelectedDepto(null);
    setSelectedCentroCusto(null);
    setSelectedDeptoOrcamento(null)
    setItemList([]);
  };

  const save = async (list: any) => {
    if (validate()) {
      setLoading(true);
      if (accountSelected?.id === undefined) {
        await addRegister(list);
      } else {
        await updateRegister(list);
      }
      setLoading(false);
      showModal(false);
      cleanInput();
      await loadData();
    }
  };

  const addRegister = async (list: any[]) => {
    const obj = {
      categoriaLancamentoId: selectedCategoria?.id,
      centroCustoId: selectedCentroCusto?.id,
      competencia: accountSelected?.competencia,
      dataEmissao: accountSelected?.dataEmissao,
      condicaoPagamentoId: selectedCondicaoPagamentos?.id,
      historico: accountSelected?.historico,
      ocorrenciaId: accountSelected?.ocorrenciaId,
      numDocumento: accountSelected?.numDocumento,
      parcelaVencimento: Number(accountSelected?.parcelaVencimento),
      usuarioId: selectedUser?.id,
      idEmpresa: usuario?.idEmpresa,
      pessoaId: selectedFornecedor?.id,
      parcela: Number(selectedCondicaoPagamentos?.parcelas),
      valor: Number(accountSelected?.valor),
      vencimento: accountSelected?.vencimento,
      vencOriginal: accountSelected?.vencOriginal,
      subCategoriaLancamentoId: selectedSubCategoria?.id,
      tipoRecebimento: accountSelected?.tipoRecebimento,
      contaFinanceiroId :  selectedConta.id,
      origem : accountSelected?.origem,
      orcamentoDeptoId : selectedDeptoOrcamento.id,
      empresaSaiadaId: selectedFilial.id
    };

    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/contas-pagar/",
      obj
    );
    if (response.data) {
      const item: ContasPagar = response.data;
      if (list.length > 0) {
        const imageList = await uploadPictures(list);
        for (let i = 0; i < imageList.length; i++) {
          const image = imageList[i];
          const arquivo = {
            contasPagarId: item.id,
            arquivoId: image.id,
          };
          await axios.post(
            process.env.REACT_APP_API_URL + "/contas-pagar/arquivo/create",
            arquivo
          );
        }
      }

      if (itemList.length > 0) {
        for (let j = 0; j < itemList.length; j++) {
          const element = itemList[j];
          const finan = {
            acrescimo: element.acrescimo,
            competencia: element.competencia,
            data: element.data,
            desconto: element.desconto,
            idEmpresa: element.idEmpresa,
            idPessoa: element.idPessoa,
            texto: `Referente a conta a pagar de ${moment(element.data).format(
              "DD/MM/yyyy"
            )} com vencimento em ${moment(element.vencimento).format(
              "DD/MM/yyyy"
            )}`,
            vencimento: element.vencimento,
            valor: element.valor,
            tipo: element.tipo,
            contaReceberId: item.id,
            tipoRecebimento: element.tipoRecebimento,
            obs: element.obs ?? ""
          };
          await axios.post(process.env.REACT_APP_API_URL + "/lancamento", finan);
        }
      }
      setLoading((prev) => (prev = false));
      cleanInput();
      showModal(false);
    }
  };

  const updateRegister = async (list: any[]) => {
    const obj = {
      categoriaLancamentoId: selectedCategoria?.id,
      centroCustoId: selectedCentroCusto?.id,
      competencia: accountSelected?.competencia,
      dataEmissao: accountSelected?.dataEmissao,
      condicaoPagamentoId: selectedCondicaoPagamentos?.id,
      historico: accountSelected?.historico,
      ocorrenciaId: accountSelected?.ocorrenciaId,
      numDocumento: accountSelected?.numDocumento,
      parcelaVencimento: Number(accountSelected?.parcelaVencimento),
      usuarioId: selectedUser?.id,
      idEmpresa: usuario?.idEmpresa,
      pessoaId: selectedFornecedor?.id,
      parcela: Number(selectedCondicaoPagamentos?.parcelas),
      valor: Number(accountSelected?.valor),
      vencimento: accountSelected?.vencimento,
      vencOriginal: accountSelected?.vencOriginal,
      subCategoriaLancamentoId: selectedSubCategoria?.id,
      tipoRecebimento: accountSelected?.tipoRecebimento,
      contaFinanceiroId :  selectedConta.id,
      origem : accountSelected?.origem,
      orcamentoDeptoId : selectedDeptoOrcamento.id,
      empresaSaiadaId: selectedFilial.id
    };

    const response = await axios.patch(
      process.env.REACT_APP_API_URL + "/contas-pagar/" + accountSelected.id,
      obj
    );
    if (response.data) {
      const item: ContasPagar = response.data;
      const newlist: any[] = [];
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          const itemValue = list[i];
          const existe = accountSelected?.ContasPagarArquivo.find((ca) =>
            ca?.arquivo?.fileName?.includes(itemValue?.name)
          );
          if (!existe) {
            newlist.push(itemValue);
          }
        }
        if (oldList.length > 0) {
          for (let index = 0; index < oldList.length; index++) {
            const el = oldList[index];
            try {
              axios.delete(process.env.REACT_APP_API_URL + "/lancamento/" + el.id);
            } catch (e) {
              console.log(e);
            }
          }
        }
        if (newlist.length > 0) {
          const imageList = await uploadPictures(newlist);
          for (let i = 0; i < imageList.length; i++) {
            const image = imageList[i];
            const arquivo = {
              contasPagarId: item.id,
              arquivoId: image.id,
            };
            await axios.post(
              process.env.REACT_APP_API_URL + "/contas-pagar/arquivo/create",
              arquivo
            );
          }
        }
      }

      if (itemList.length > 0) {
        for (let j = 0; j < itemList.length; j++) {
          const element = itemList[j];
          const finan = {
            acrescimo: element.acrescimo,
            competencia: element.competencia,
            data: element.data,
            desconto: element.desconto,
            idEmpresa: element.idEmpresa,
            idPessoa: element.idPessoa,
            texto: `Referente a conta a pagar de ${moment(element.data).format(
              "DD/MM/yyyy"
            )} com vencimento em ${moment(element.vencimento).format(
              "DD/MM/yyyy"
            )}`,
            vencimento: element.vencimento,
            valor: element.valor,
            tipo: element.tipo,
            contaReceberId: item.id,
            tipoRecebimento: element.tipoRecebimento,
            obs: element.obs ?? ""
          };
          await axios.post(process.env.REACT_APP_API_URL + "/lancamento", finan);
        }
      }
      setLoading((prev) => (prev = false));
      cleanInput();
      showModal(false);
    }
  };

  const uploadPictures = async (list: any[]) => {
    let formData = new FormData();
    if (list.length > 0) {
      for (let i = 0; i < list.length; i++) {
        const file = list[i];
        formData.append("arquivos", file);
      }
    }
    const response = await axios.postForm(
      process.env.REACT_APP_API_URL + "/arquivo/multiplo",
      formData
    );
    if (response.data) {
      const newlist: ArquivoUpload[] = response.data;
      return newlist;
    }
  };

  const edit = async (item: ContasPagar) => {
    showModal(true);
    setAccountSelected(item);
    await loadFinanceiro(item.id);
  };

  const showDeleteModal = (item: ContasPagar) => {
    setShowDelete(true);
    setAccountSelected(item);
  };

  const closeDelete = () => {
    setShowDelete(false);
  };

  const deletar = async () => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + "/contas-pagar/" + accountSelected?.id
    );
    if (response.data) {
      if (itemList.length > 0) {
        for (let index = 0; index < itemList.length; index++) {
          const el = itemList[index];
          try {
            axios.delete(process.env.REACT_APP_API_URL + "/lancamento/" + el.id);
          } catch (e) {
            console.log(e);
          }
        }
      }
      setLoading((prev) => (prev = false));
      showModal(false);
      setAccountSelected(null);
      setShowDelete(false);
      await loadData();
    }
  };

  const changeFornecedor = (item: string) => {
    const selected = fornecedores?.find((f) => f.id === item);
    if (selected) {
      setSelectedFornecedor(selected);
    }
  };

  const changeDepto = (item: string) => {
    const selected = depto?.find((f) => f.id === item);
    if (selected) {
      setSelectedDepto(selected);
      setCentroCusto(selected.CentroCusto);
    }
  };

  const changeConta = (item: string) => {
    const selected = contaFinanceiroLista?.find((f) => f.id === item);
    if (selected) {
      setSelectedConta(selected);
    }
  };

  const changeUser = (item: string) => {
    const selected = users?.find((f) => f.id === item);
    if (selected) {
      setSelectedUser(selected);
    }
  };

  const changeCategoria = (item: string) => {
    const selected = categoria?.find((f) => f.id === item);
    if (selected) {
      setSelectedCategoria(selected);
      setSubCategoria(selected.SubCategoriaLancamento);
    }
  };

  const changeSubCategoria = (item: string) => {
    const selected = lista?.find((f) => f.id === item);
    if (selected) {
      setSelectedSubCategoria(selected);
    }
  };

  const changeCentroCusto = (item: string) => {
    const selected = centroCusto?.find((f) => f.id === item);
    if (selected) {
      setSelectedCentroCusto(selected);
    }
  };

  const changeCondicaoPagamento = (item: string) => {
    const selected = condicaoPagamentos?.find((f) => f.id === item);
    if (selected) {
      setSelectedCondicaoPagamentos(selected);
    }
  };

  const changeDeptoOrcamento = (item: string) => {
    const selected = listDepto?.find((f) => f.id === item);
    if (selected) {
      setSelectedDeptoOrcamento(selected);;
    }
  };

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };

  const closeError = () => {
    setError(false);
  };

  const changeInput = (value: any, type: string) => {
    switch (type) {
      case "vencOriginal":
        setAccountSelected({ ...accountSelected, vencOriginal: value });
        break;
      case "valor":
        setAccountSelected({ ...accountSelected, valor: value });
        break;
      case "vencimento":
        const date = moment(value).format("DD");
        setAccountSelected({
          ...accountSelected,
          vencimento: value,
          parcelaVencimento: Number(date),
        });
        break;
      case "dataEmissao":
        setAccountSelected({ ...accountSelected, dataEmissao: value });
        break;
      case "numDocumento":
        setAccountSelected({ ...accountSelected, numDocumento: value });
        break;
      case "competencia":
        setAccountSelected({ ...accountSelected, competencia: value });
        break;
      case "historico":
        setAccountSelected({ ...accountSelected, historico: value });
        break;
      case "parcelaVencimento":
        setAccountSelected({ ...accountSelected, parcelaVencimento: value });
        break;
      case "parcela":
        setAccountSelected({ ...accountSelected, parcela: value });
        break;
      case "subCategoriaLancamentoId":
        setAccountSelected({
          ...accountSelected,
          subCategoriaLancamentoId: value,
        });
        break;
      case "tipoRecebimento":
        setAccountSelected({ ...accountSelected, tipoRecebimento: value });
        break;
      case "origem":
        setAccountSelected({
          ...accountSelected,
          origem: value,
        });
        break;
    }
  };

  const getLink = async (id: string) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/arquivo/" + id);
    console.log(response, "response.data");
    if (response.data) {
      return response.data;
    }
  };

  const loadFinanceiro = async (id: string) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/lancamento/contasreceber/" + id
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      const newData: LancamentoFinanceiro[] = response.data;
      setItemList(newData);
      setOldList(newData);
    }
  };

  const addRowItem = (item: LancamentoFinanceiro) => {
    const itens = [...itemList];
    const existe = itens.find(
      (a) =>
        moment(a.vencimento).format("DD/MM/yyyy") ===
        moment(item.vencimento).format("DD/MM/yyyy")
    );
    console.log(existe, "existe");
    if (existe) {
      showError("Erro!", "Lançamento Já Cadastrado");
    } else {
      itens.push(item);
    }
    setItemList(itens);
  };

  const deleteRow = (item: LancamentoFinanceiro) => {
    const newList = itemList.filter((dt) => dt !== item);
    setItemList(newList);
  };

  const editRow = (item: LancamentoFinanceiro) => {
    const newItems: LancamentoFinanceiro[] = itemList.map((existingItem) => {
      if (
        moment(existingItem.vencimento).format("DD/MM/yyyy") ===
        moment(item.vencimento).format("DD/MM/yyyy")
      ) {
        return item;
      }
      return existingItem;
    });
    setItemList(newItems);
  };

  const generateParcela = (
    item: string,
    vencimento: Date,
    valor: number,
    fornecedor: string,
    tipoRecebimento: string,
  ) => {
    const newList: LancamentoFinanceiro[] = [];

    const selected = condicaoPagamentos?.find((f) => f.id === item);
    const sFrn = fornecedores.find((a) => a.id === fornecedor);

    if (selected) {
      setSelectedCondicaoPagamentos(selected);
    }
    if (!vencimento) {
      showError("Erro!", "Selecione o dia de vencimento!");
      return;
    }
    if (!valor) {
      showError("Erro!", "Preencha corretamente o campo valor!");
      return;
    }

    if (!selectedFornecedor) {
      showError("Erro!", "Selecione o Favorecido!");
      return;
    }
    const valorParcela = valor / selected?.parcelas;
    const diaCorrente = moment();
    const itemDate = moment(vencimento).add({ day: 1 }).format("DD");
    for (let i = 0; i < selected?.parcelas; i++) {
      let dataParcela = moment().set("date", Number(itemDate));
      if (diaCorrente.isAfter(dataParcela)) {
        dataParcela.add({ month: 1 });
      }
      const newDate = dataParcela
        .add({ month: i })
        .format("YYYY-MM-DD")
        .toString();
      const itemData = new Date(newDate);

      const obj: LancamentoFinanceiro = {
        acrescimo: 0,
        competencia: accountSelected?.competencia,
        data: new Date(),
        desconto: 0,
        idEmpresa: usuario?.idEmpresa,
        idPessoa: sFrn?.id,
        marcado: false,
        pago: i === 0 && selected.baixaPrimeira ? true : false,
        texto: "",
        tipo: "1",
        valor: valorParcela,
        vencimento: itemData,
        id: "",
        contaPagarId: "",
        contaReceberId: "",
        dataPago: new Date(),
        obs: "",
        tipoRecebimento : tipoRecebimento
      };
      newList.push(obj);
    }
    setTimeout(() => {
      setItemList(newList);
    }, 300);
  };

  const loadEmpresas = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/orcamento/filial/" + userData?.idEmpresa
    );
    if (response.data) {
      setFilial(response.data);
    }
  };


  const onChangeFilial = (item: string) => {
    const selected = filiais.find((a) => a.id === item);
    if (selected) {
      setSelectedFilial(selected);
    }
  }


  useEffect(() => {
    const initialize = async () => {
      try {
        await Promise.all([
          loadData(),
          loadPagamento(),
          loadDepto(),
          loadCategory(),
          loadFornecedores(),
          loadContaFinaceiro(),
          loadUsers(),
          loadOrcamentoDepto(),
          loadEmpresas(),
        ]);
      } catch (error) {
        // Handle errors if needed
        console.error("Error during initialization:", error);
      }
    };

    initialize();
  }, []);
  return {
    list,
    add,
    edit,
    loading,
    show,
    showModal,
    accountSelected,
    error,
    save,
    deletar,
    showDeleteModal,
    showDelete,
    closeDelete,
    cancelRef,
    depto,
    categoria,
    centroCusto,
    condicaoPagamentos,
    loadFornecedores,
    fornecedores,
    errorMsg,
    errorTitle,
    showError,
    closeError,
    selectedFornecedor,
    selectedCategoria,
    selectedCentroCusto,
    selectedCondicaoPagamentos,
    selectedDepto,
    changeFornecedor,
    changeDepto,
    changeCategoria,
    changeCentroCusto,
    changeCondicaoPagamento,
    changeInput,
    uploadPictures,
    getLink,
    changeSubCategoria,
    subcategoria,
    selectedSubCategoria,
    addRowItem,
    editRow,
    deleteRow,
    itemList,
    usuario,
    generateParcela,
    contaFinanceiroLista,
    changeConta,
    selectedConta,
    users,
    selectedUser,
    changeUser,
    listDepto,
    selectedDeptoOrcamento,
    changeDeptoOrcamento,
    filiais,
    selectedFilial,
    onChangeFilial
  };
};
export default useContasPagar;
